import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {FiLock} from 'react-icons/fi';
import {resetPassword} from '../../api/api';
import AuthFlowLayout from './AuthFlowLayout';

export default function ResetPassword() {
  const navigate = useNavigate();
  const {state} = useLocation();
  const email = state?.email || '';
  const otp = state?.otp || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleReset = async e => {
    e.preventDefault();
    if (!email || !otp) return setMessage('Your reset session expired. Please request a new OTP.');
    if (!password || !confirmPassword) return setMessage('Both password fields are required.');
    if (password.length < 8) return setMessage('Password must be at least 8 characters.');
    if (password !== confirmPassword) return setMessage('Passwords do not match.');
    try {
      setLoading(true); setMessage('');
      await resetPassword({email, otp, newPassword: password});
      navigate('/');
    } catch (err) {
      setMessage(err.response?.data?.message || err.message || 'Password reset failed.');
    } finally { setLoading(false); }
  };

  return (
    <AuthFlowLayout eyebrow="Account recovery" heroTitle="Choose a new password" heroText="Create a strong password to secure your YaBatho customer account." icon={<FiLock />} benefitTitle="Keep it secure" benefitText="Use at least eight characters and avoid passwords used elsewhere." formEyebrow="Final step" title="Reset password" subtitle={<>Set a new password for <strong>{email || 'your account'}</strong>.</>}>
      <form onSubmit={handleReset} className="auth-flow-form">
        <label className="auth-flow-label" htmlFor="new-password">New password</label>
        <input id="new-password" className="auth-flow-input" type="password" autoComplete="new-password" placeholder="At least 8 characters" value={password} onChange={e => setPassword(e.target.value)} />
        <label className="auth-flow-label" htmlFor="confirm-password">Confirm password</label>
        <input id="confirm-password" className="auth-flow-input" type="password" autoComplete="new-password" placeholder="Enter it again" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
        {message && <p className="auth-flow-message" role="alert">{message}</p>}
        <button className="auth-flow-submit" type="submit" disabled={loading}>{loading ? 'Resetting...' : 'Reset password'}</button>
      </form>
      <button className="auth-flow-back" type="button" onClick={() => navigate('/')}>Back to Login</button>
    </AuthFlowLayout>
  );
}
